import * as types from "./mutation-type.js";

export default {
  [types.Change_Cate](state, id) {
    state.customerCate = id;
  },
  [types.SET_Customer_Keyword](state, keyword) {
    state.customerKeyword = keyword;
  },
  [types.SET_USER_INFO](state, name) {
    state.userInfo = name;
  },
  [types.UPDATE_ISCHECKTOKEN](state, name) {
    state.isCheckToken = name;
  },
  [types.SET_APIHOST](state, name) {
    state.apiHost = name;
  },
  [types.SET_LEFTMENUNAV](state, name) {
    state.leftMenuNav = name;
  },
  [types.SET_USERINFO](state, name) {
    state.userInfo = name;
  },

  [types.SET_NAME](state, name) {
    state.name = name;
  },
  [types.SET_AGE](state, age) {
    state.age = age;
  },
  [types.SET_SEND_USERINFO](state, send_userinfo) {
    state.send_userinfo = send_userinfo;
  },
  [types.SET_PERSONL](state, personl) {
    state.personl = personl;
  },
  [types.SET_ACTIVEINDEX](state, activeIndex) {
    state.activeIndex = activeIndex;
  },
  [types.SET_NCHANGEDATA](state, changData) {
    state.changData = changData;
  },
  [types.SET_QUERYSEARCH](state, query_search) {
    state.query_search = query_search;
  },
  [types.SET_QUESTIONCHANGE](state, questionChange) {
    state.questionChange = questionChange;
  },
  [types.SET_DELQUESTION](state, delQuestion) {
    state.delQuestion = delQuestion;
  },
  [types.SET_ISITCSCENCE](state, isItcScene) {
    state.isItcScene = isItcScene;
  },
};
